export class NeoMontoIntermediarioDTO {
  constructor(
    public idMontoIntermediario: Number,
    public montoFinal: Number,
    public montoInicial: Number,
    public idCliente_NeoCliente: Number,
    public idUsuario: Number,
    public justificacion: String
  ) {}
}
